export const DOCUMENT_NAME_MAX_LENGTH = 300;
